import http from 'http';
import * as ErrorCodes from './error-codes';
import _ from 'lodash';

export const findCode = (code) => {
    return Object.values(ErrorCodes).find(error => error.errorCode === code);
};

export const getErrorResponseMessage = (errorResponse) => {
    let errorMessage;
    const data = _.get(errorResponse, ['data'], {});
    const status = _.get(errorResponse, ['status'], {});
    if (!_.isNil(data.message)) {
        errorMessage = data.message;
    } else if (!_.isNil(data.error)) {
        errorMessage = data.error;
    } else if (!_.isEmpty(status)) {
        const label = !_.isNil(http.STATUS_CODES[status]) ? http.STATUS_CODES[status] : 'Unknown error';
        errorMessage = `${label} occured but the error response is not structured correctly`;
    } else {
        errorMessage = `An error occured but does not look like an Axios error`;
    }
    return errorMessage;
};

